// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Qwxp","header":"_1mMY9","content":"_2uQ2d"};